var _g, _g2, _g3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneShot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "One_Shot",
    "data-name": "One Shot",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    fill: "none",
    stroke: "#4a61b4",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 9,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 7,
    rx: 2,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    transform: "translate(0 12)",
    fill: "none",
    stroke: "#4a61b4",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 9,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 7,
    rx: 2,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    transform: "translate(0 26)",
    fill: "none",
    stroke: "#4a61b4",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 9,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 7,
    rx: 2,
    fill: "none"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(16)",
    fill: "#446ce3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(22 12)",
    fill: "#446ce3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(11 26)",
    fill: "#446ce3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneShot);
export default __webpack_public_path__ + "static/media/one_shot.7fd72af9d37c745f36dbf5cfb39eb8b6.svg";
export { ForwardRef as ReactComponent };